import * as React from 'react';
export const TGSvg = React.forwardRef(function TGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 11V5h1v6h-1ZM0 5h1v6H0V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M1.994 2h12.012C15.106 2 16 2.895 16 4v1H0V4c0-1.112.893-2 1.994-2ZM0 11h16v1.5a1.5 1.5 0 0 1-1.505 1.5H1.505A1.498 1.498 0 0 1 0 12.5V11Zm0-4h16v2H0V7Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 2h5v7H0V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'm5.71 4.637-1.432.003a.199.199 0 0 1-.19-.138L3.645 3.14a.199.199 0 0 0-.38 0l-.442 1.362a.199.199 0 0 1-.19.137H1.202A.199.199 0 0 0 1.084 5l1.159.842c.07.05.099.141.072.223l-.442 1.363a.199.199 0 0 0 .307.223l1.158-.778a.199.199 0 0 1 .235 0l1.159.778a.199.199 0 0 0 .307-.223l-.443-1.363a.199.199 0 0 1 .072-.223L5.827 5a.202.202 0 0 0-.117-.363Z',
      }),
    ),
  );
});
TGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TG = {
  category: 'flag',
  colorable: false,
  name: 'TG',
  svg: TGSvg,
};
